class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    this.querySelectorAll('.facets-item input[type="radio"], .facets-item input[type="checkbox"]').forEach((input) => {
      input.addEventListener('change', function () {
        const parent = input.closest('.facets-item');
        if (!parent) return;
        if (input.checked) {
          parent.classList.add('active');
        } else {
          parent.classList.remove('active');
        }
        // For radio: remove 'active' from siblings
        if (input.type === 'radio') {
          parent.parentElement.querySelectorAll('.facets-item').forEach((item) => {
            if (item !== parent) item.classList.remove('active');
          });
        }
      });
      // Set initial state
      if (input.checked) {
        const parent = input.closest('.facets-item');
        if (parent) parent.classList.add('active');
      }
    });

    this.querySelectorAll('.facets-value-search-input').forEach((input) => {
      input.addEventListener('input', this.onSearchInput.bind(this));
    });
  }

  onSearchInput(event) {
    const input = event.target;
    const parent = input.closest('.parent-display');
    const query = input.value;

    if (query.length > 0) {
      parent.querySelector('.label-show-more').classList.add('hidden');
      parent.querySelector('.label-show-less').classList.add('hidden');
      parent.querySelectorAll('.show-more-item').forEach((item) => item.classList.remove('hidden'));
      parent.querySelectorAll('li').forEach((item) => {
        if (!item.dataset.label.toLowerCase().includes(query.toLowerCase())) {
          item.classList.add('hidden');
        }
      });
    } else {
      parent.querySelector('.label-show-more').classList.remove('hidden');
      parent.querySelector('.label-show-less').classList.add('hidden');
      parent.querySelectorAll('li').forEach((item) => item.classList.remove('hidden'));
      parent.querySelectorAll('.show-more-item').forEach((item) => item.classList.add('hidden'));
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    FacetFiltersForm.getSections().forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductCount(html);
        FacetFiltersForm.renderFacetsDrawerHeader(html);
        FacetFiltersForm.renderFacetsDrawerFooter(html);
        FacetFiltersForm.renderProductGridContainer(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductCount(html);
    FacetFiltersForm.renderFacetsDrawerHeader(html);
    FacetFiltersForm.renderFacetsDrawerFooter(html);
    FacetFiltersForm.renderProductGridContainer(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderFacetsDrawerHeader(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetsDrawerHeader = parsedHTML.querySelector('.facets-container-drawer-header');
    if (facetsDrawerHeader) {
      document.querySelector('.facets-container-drawer-header').innerHTML = facetsDrawerHeader.innerHTML;
    }
  }

  static renderFacetsDrawerFooter(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetsDrawerFooter = parsedHTML.querySelector('.facets-container-drawer-footer');
    if (facetsDrawerFooter) {
      document.querySelector('.facets-container-drawer-footer').innerHTML = facetsDrawerFooter.innerHTML;
    }
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

      // Dispatch custom event after AJAX filter update
    if (typeof window.CustomEvent === 'function') {
      const event = new CustomEvent('facets:updated', { bubbles: true });
      document.getElementById('ProductGridContainer').dispatchEvent(event);
    }
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    container.innerHTML = count;
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

class FacetsDrawer extends HTMLElement {
  constructor() {
    super();

    this.bindEvents();

    const productsGridNode = document.getElementById('ProductGridContainer');
    if (productsGridNode) {
      productsGridNode.addEventListener('facets:updated', this.bindEvents.bind(this));
    }
  }

  bindEvents() {
    const openerNode = document.getElementById('FacetsFiltersOpen');
    if (openerNode) {
      openerNode.addEventListener('click', this.open.bind(this));
    }

    const closeNodes = this.querySelectorAll('.facets-container-drawer .facets-close');
    if (closeNodes && closeNodes.length > 0) {
      closeNodes.forEach((node) => {
        node.addEventListener('click', this.close.bind(this));
      });
    }

    const overlayNode = this.querySelector('.facets-overlay');
    if (overlayNode) {
      overlayNode.addEventListener('click', this.close.bind(this));
    }

    const headerNode = this.querySelector('.facets-container-drawer-header');
    const drawerNode = this.querySelector('.facets-container-drawer');

    if (headerNode && drawerNode) {
      drawerNode.style.setProperty('--facets-drawer-header-height', headerNode.offsetHeight + 'px');
    }
  }

  open(e) {
    if (e) {
      e.preventDefault();
    }

    this.querySelector('.facets-container-drawer').classList.add('active');
    this.querySelector('.facets-overlay').classList.add('active');
    document.body.classList.add('overflow-hidden');
  }

  close(e) {
    if (e) {
      e.preventDefault();
    }

    this.querySelector('.facets-container-drawer').classList.remove('active');
    this.querySelector('.facets-overlay').classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('facets-drawer', FacetsDrawer);
